import { AllPaginationDefaults } from '../enum';
import { PaginationRequest } from '../Types';

export const requestAllItem: PaginationRequest = {
    page:  AllPaginationDefaults.Page as number,
    pageSize: AllPaginationDefaults.PageSize as number,
    order: AllPaginationDefaults.Order as string,
    orderBy: AllPaginationDefaults.OrderBy as string,
};